import { render, staticRenderFns } from "./InviteMemberToPracticePage.vue?vue&type=template&id=6213082f"
import script from "./InviteMemberToPracticePage.vue?vue&type=script&lang=js"
export * from "./InviteMemberToPracticePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports